import { makeAutoObservable } from "mobx"

export class AnswerFeedbackStore {
  constructor(options: {
    rating: number
    reason?: string
    editable?: boolean
  }) {
    makeAutoObservable(this)

    this.comment = options.reason ?? ""
    this.rating = options.rating
    this.isEditable = options.editable ?? true
  }

  isLoading: boolean = false

  rating: number

  comment: string

  data: string | null = null

  error: string | null = null

  isEditable: boolean

  setRating = (rating: number) => {
    this.rating = rating
  }
}

export default AnswerFeedbackStore
